package com.raouf.mehrguard.web.i18n

internal val KoreanStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "Kotlin 멀티플랫폼 QRishing 탐지기",
    WebStringKey.MenuMain to "메인 메뉴",
    WebStringKey.MenuSecurity to "보안",
    WebStringKey.MenuSystem to "시스템",
    WebStringKey.NavDashboard to "대시보드",
    WebStringKey.NavScanMonitor to "스캔 모니터",
    WebStringKey.NavScanHistory to "스캔 기록",
    WebStringKey.NavTrustCentre to "신뢰 센터",
    WebStringKey.NavReports to "보고서",
    WebStringKey.NavTraining to "교육",
    WebStringKey.NavSettings to "설정",
    WebStringKey.QuickActions to "빠른 작업",

    // Hero Section
    WebStringKey.HeroTagline to "안전. 오프라인.",
    WebStringKey.HeroTagline2 to "설명 가능한 방어.",
    WebStringKey.HeroDescription to "Mehr Guard는 하드웨어에서 직접 잠재적 위협을 분석합니다. 제로 레이턴시 보호를 경험하세요.",

    // Dashboard
    WebStringKey.StartScan to "새 스캔 시작",
    WebStringKey.ImportImage to "이미지 가져오기",
    WebStringKey.ScanQrCode to "QR 코드 스캔",
    WebStringKey.SystemHealth to "시스템 상태",
    WebStringKey.ThreatDatabase to "위협 데이터베이스",
    WebStringKey.Current to "현재",
    WebStringKey.Active to "활성",
    WebStringKey.Threats to "위협",
    WebStringKey.SafeScans to "안전한 스캔",
    WebStringKey.EngineActive to "엔진 활성화",
    WebStringKey.EnterpriseProtection to "기업 보호 활성화",
    WebStringKey.SystemOptimal to "시스템 최적",
    WebStringKey.EngineStatus to "엔진 v2.4 • 2시간 전 업데이트됨",
    WebStringKey.ThreatsBlocked to "차단된 위협",
    WebStringKey.AllSystemsOperational to "모든 시스템 정상 작동 중",

    // Dashboard Sections
    WebStringKey.SectionOverview to "개요",
    WebStringKey.SectionSecurity to "보안",
    WebStringKey.SectionTraining to "교육",
    WebStringKey.SectionReports to "보고서",
    WebStringKey.OfflineReady to "오프라인 준비 완료",
    WebStringKey.OfflineDescription to "로컬 데이터베이스 v2.4.1 활성화. 이 기기에서 데이터가 유출되지 않습니다.",

    // Trust Centre
    WebStringKey.TrustCentreTitle to "신뢰 센터",
    WebStringKey.OfflineGuarantee to "엄격한 오프라인 보장",
    WebStringKey.OfflineGuaranteeDesc to "Mehr Guard 분석은 기기의 Neural Engine에서 완전히 실행됩니다. URL 데이터는 절대 휴대폰을 떠나지 않습니다.",
    WebStringKey.ThreatSensitivity to "위협 민감도",
    WebStringKey.ResetConfirm to "신뢰 센터 설정이 기본값으로 재설정됩니다.",

    // Settings Quick Actions
    WebStringKey.ThreatMonitor to "위협 모니터",
    WebStringKey.ThreatMonitorDesc to "실시간 위협 보기 및 보안 감사 실행",
    WebStringKey.TrustCentreDesc to "개인정보 설정 및 위협 민감도",
    WebStringKey.ExportReport to "보고서 내보내기",
    WebStringKey.ExportReportDesc to "PDF 또는 JSON 보안 보고서 생성",

    // Dashboard Content
    WebStringKey.Analyze to "분석",
    WebStringKey.HeuristicEngine to "휴리스틱 엔진",
    WebStringKey.HighPerformanceEngine to "고성능 엔진",
    WebStringKey.RecentScans to "최근 스캔",
    WebStringKey.ViewFullHistory to "전체 기록 보기",
    WebStringKey.Status to "상태",
    WebStringKey.Source to "소스",
    WebStringKey.Details to "세부 정보",
    WebStringKey.Time to "시간",
    WebStringKey.Version to "버전",
    WebStringKey.LastUpdate to "마지막 업데이트",
    WebStringKey.Signatures to "서명",
    WebStringKey.CheckForUpdates to "업데이트 확인",
    WebStringKey.FeatureOfflineTitle to "오프라인 우선 아키텍처",
    WebStringKey.FeatureOfflineDesc to "완전한 분석이 로컬에서 수행됩니다. 카메라 피드와 스캔된 데이터는 절대 외부 서버에 닿지 않아 완전한 프라이버시를 보장합니다.",
    WebStringKey.FeatureExplainableTitle to "설명 가능한 보안",
    WebStringKey.FeatureExplainableDesc to "단순히 \"차단\"만 받지 마세요. URL 매개변수, 리디렉션 및 자바스크립트 페이로드에 대한 상세한 휴리스틱 분석을 제공합니다.",
    WebStringKey.FeaturePerformanceDesc to "데스크톱 환경에 최적화되었습니다. 스캔은 네이티브 Kotlin Multiplatform 바이너리를 사용하여 5ms 미만에 처리됩니다.",
    WebStringKey.TrainingCentre to "교육 센터",
    WebStringKey.LearnHomograph to "고급 QR 동형 문자 공격을 식별하는 방법을 배우세요.",
    WebStringKey.BeatTheBotAction to "봇을 이겨라 →",
    WebStringKey.NoScansYet to "아직 스캔이 없습니다. 새 스캔을 시작하여 여기에서 결과를 확인하세요.",
    WebStringKey.VerdictSafe to "안전",
    WebStringKey.VerdictPhish to "피싱",
    WebStringKey.VerdictWarn to "경고",
    WebStringKey.ScoreLabel to "점수:",

    // Scanner
    WebStringKey.ActiveScanner to "활성 스캐너",
    WebStringKey.OfflineMode to "오프라인 모드",
    WebStringKey.LiveFeedDisconnected to "라이브 피드 연결 끊김",
    WebStringKey.CameraAccessRequired to "카메라 액세스 필요",
    WebStringKey.CameraAccessDescription to "QR 코드 이미지를 여기로 드래그 앤 드롭하거나 카메라 액세스를 활성화하여 스캔을 시작하세요.",
    WebStringKey.EnableCamera to "카메라 활성화",
    WebStringKey.Scanning to "스캔 중...",
    WebStringKey.ScanHint to "고정하세요. <5ms 내에 오프라인으로 분석됩니다.",
    WebStringKey.Torch to "손전등",
    WebStringKey.Gallery to "갤러리",
    WebStringKey.PasteUrl to "URL 붙여넣기",
    WebStringKey.PasteUrlTitle to "분석할 URL 붙여넣기",
    WebStringKey.AnalyzeUrl to "URL 분석",
    WebStringKey.SystemStatus to "시스템 상태",
    WebStringKey.PhishingEngine to "피싱 엔진",
    WebStringKey.Ready to "준비",
    WebStringKey.LocalDb to "로컬 DB",
    WebStringKey.Latency to "지연",
    WebStringKey.ViewAll to "모두 보기",

    // Threat / Results
    WebStringKey.BreadcrumbHome to "홈",
    WebStringKey.BreadcrumbScans to "스캔",
    WebStringKey.OfflineProtection to "오프라인 보호",
    WebStringKey.VerdictHighRisk to "높은 위험 감지됨",
    WebStringKey.VerdictDangerous to "위험",
    WebStringKey.VerdictDangerousDesc to "스캔된 QR 코드에는 피싱 및 자격 증명 수집과 관련된 악성 지표가 포함되어 있습니다. 대상 URL로 진행하지 마세요.",
    WebStringKey.ThreatConfidence to "위협 신뢰도",
    WebStringKey.FlagPhishing to "피싱 시도",
    WebStringKey.FlagObfuscated to "난독화된 스크립트",
    WebStringKey.FlagHomograph to "동형 문자 공격",
    WebStringKey.ClearHistory to "모두 삭제",
    WebStringKey.SectionAttackBreakdown to "공격 분석",
    WebStringKey.AttackHomographTitle to "동형 문자 / IDN 공격",
    WebStringKey.AttackHomographDesc to "라틴 알파벳을 모방하는 키릴 문자가 감지되었습니다.",
    WebStringKey.AttackVisualLabel to "시각적 모양",
    WebStringKey.AttackPunycodeLabel to "실제 Punycode",
    WebStringKey.AttackHomographExplain to "도메인이 라틴 'a'(U+0061) 대신 키릴 'а'(U+0430)를 사용합니다. 이 기술은 사용자가 합법적인 서비스를 방문한다고 믿도록 속이는 데 일반적으로 사용됩니다.",
    WebStringKey.AttackRedirectTitle to "의심스러운 리디렉션 체인",
    WebStringKey.AttackRedirectDesc to "알려진 URL 단축 서비스를 포함하는 3개의 홉이 감지되었습니다.",
    WebStringKey.RedirectStart to "QR 코드 스캔",
    WebStringKey.RedirectHop to "중간 홉",
    WebStringKey.RedirectFinal to "최종 목적지",
    WebStringKey.AttackJsTitle to "난독화된 JavaScript",
    WebStringKey.AttackJsDesc to "URL 매개변수에서 높은 엔트로피 문자열이 감지되었습니다.",
    WebStringKey.SectionActions to "권장 조치",
    WebStringKey.ActionBlock to "차단 및 신고",
    WebStringKey.ActionBlockDesc to "액세스 방지 및 관리자 알림",
    WebStringKey.ActionQuarantine to "샌드박스에서 격리",
    WebStringKey.ActionQuarantineDesc to "분석을 위해 안전하게 열기",
    WebStringKey.Expected to "예상: ",
    WebStringKey.Detected to "감지됨: ",
    WebStringKey.ExplainableSecurity to "설명 가능한 보안",
    WebStringKey.UrlBreakdown to "URL 분석",
    WebStringKey.FullUrl to "전체 URL",
    WebStringKey.OpenInBrowser to "브라우저에서 열기 (위험)",
    WebStringKey.OpenWarning to "이 URL을 브라우저에서 열면 보안 위험에 노출될 수 있습니다.",
    WebStringKey.RestrictedMode to "제한 모드",
    WebStringKey.RestrictedDesc to "이 URL은 잠재적으로 위험한 것으로 표시되었습니다. 진행하기 전에 아래 분석을 검토하세요.",
    WebStringKey.DangerousWarning to "이 URL은 잠재적으로 위험한 것으로 표시되었습니다. 열면 피싱, 맬웨어 또는 기타 보안 위협에 노출될 수 있습니다. 계속하시겠습니까?",
    WebStringKey.CopyUrl to "URL 복사",
    WebStringKey.Share to "공유",
    WebStringKey.Dismiss to "닫기",
    WebStringKey.ReasonDomainAge to "도메인 나이가 24시간 미만입니다.",
    WebStringKey.ReasonSignatures to "로컬 피싱 DB에서 3개의 서명과 일치했습니다.",
    WebStringKey.ReasonAsn to "대상 IP가 고위험 ASN에 있습니다.",
    WebStringKey.SectionMeta to "스캔 메타",
    WebStringKey.MetaTime to "스캔 시간",
    WebStringKey.MetaSource to "소스",
    WebStringKey.MetaEngine to "엔진",
    WebStringKey.MetaOfflineGuaranteeLabel to "오프라인 보장:",
    WebStringKey.MetaOfflineGuaranteeDesc to "이 이미지는 기기에서 로컬로 분석되었습니다. 이 판정을 위해 클라우드로 전송된 데이터가 없습니다.",
    
    WebStringKey.ScanComplete to "스캔 완료",
    WebStringKey.Loading to "로딩 중...",
    WebStringKey.AnalyzedOffline to "5ms 미만으로 오프라인 분석",
    WebStringKey.NoDataLeaves to "데이터가 기기를 떠나지 않음",
    WebStringKey.ActiveProtection to "활성 보호",
    WebStringKey.ConfidenceScore to "신뢰 점수",
    WebStringKey.Analyzing to "분석 중...",
    WebStringKey.ProcessingResults to "스캔 결과 처리 중...",
    WebStringKey.RiskAssessment to "위험 평가",
    WebStringKey.AnalysisTime to "분석 시간",
    WebStringKey.Heuristics to "휴리스틱",
    WebStringKey.TopAnalysisFactors to "주요 분석 요인",
    WebStringKey.Pass to "통과",
    WebStringKey.Info to "정보",
    WebStringKey.Clean to "깨끗함",
    WebStringKey.ValidSslCertificate to "유효한 SSL 인증서",
    WebStringKey.SslCertificateDesc to "DigiCert Inc에서 발급한 인증서",
    WebStringKey.EstablishedDomain to "확립된 도메인",
    WebStringKey.EstablishedDomainDesc to "5년 이상 전에 등록된 도메인",
    WebStringKey.BlacklistStatus to "블랙리스트 상태",
    WebStringKey.BlacklistStatusDesc to "52개 로컬 위협 DB에서 발견되지 않음",
    WebStringKey.BackToDashboard to "대시보드로 돌아가기",
    WebStringKey.ShareReport to "보고서 공유",
    WebStringKey.CopyLink to "링크 복사",
    WebStringKey.LinkCopied to "링크가 클립보드에 복사되었습니다!",
    WebStringKey.BeatTheBot to "봇을 이겨라",
    WebStringKey.BeatTheBotDesc to "오프라인 AI에 도전",
    WebStringKey.SessionId to "세션 ID",
    WebStringKey.EndSession to "세션 종료",
    WebStringKey.Round to "라운드",
    WebStringKey.BrowserPreview to "브라우저 미리보기",
    WebStringKey.MakeDecision to "결정하세요",
    WebStringKey.Phishing to "피싱",
    WebStringKey.Legitimate to "정상",
    WebStringKey.LiveHint to "라이브 힌트",
    WebStringKey.LiveScoreboard to "라이브 스코어보드",
    WebStringKey.VsMode to "VS 모드",
    WebStringKey.You to "당신",
    WebStringKey.Points to "포인트",
    WebStringKey.Streak to "연속",
    WebStringKey.Accuracy to "정확도",
    WebStringKey.MehrGuardBot to "Mehr Guard 봇",
    WebStringKey.Confidence to "신뢰도",
    WebStringKey.RoundAnalysis to "라운드 분석",
    WebStringKey.Analysis to "분석",
    WebStringKey.CorrectDecision to "정확한 결정!",
    WebStringKey.IdentifiedSafe to "안전한 URL을 올바르게 식별",
    WebStringKey.AiNeuralAnalysis to "AI 신경망 분석",
    WebStringKey.WhyBotFlagged to "봇이 플래그한 이유",
    WebStringKey.EducationalNote to "교육 노트",
    WebStringKey.Correct to "정답!",
    WebStringKey.SpottedPhishing to "피싱 URL을 올바르게 감지",
    WebStringKey.Response to "응답",
    WebStringKey.NextRound to "다음 라운드",
    WebStringKey.GameOver to "게임 오버!",
    WebStringKey.FinalResults to "최종 결과",
    WebStringKey.YourScore to "당신의 점수",
    WebStringKey.BotScore to "봇 점수",
    WebStringKey.BestStreak to "최고 연속",
    WebStringKey.PlayAgain to "다시 플레이",
    WebStringKey.ReturnToDashboard to "대시보드로 돌아가기",
    WebStringKey.ExportSecurityReport to "보안 보고서 내보내기",
    WebStringKey.GenerateReport to "전체 보안 보고서 생성",
    WebStringKey.ReportFormat to "보고서 형식",
    WebStringKey.HumanReadable to "사람이 읽을 수 있는 보고서",
    WebStringKey.HumanReadableDesc to "시각적 분석 포함 PDF",
    WebStringKey.MachineReadable to "기계 판독 가능 데이터",
    WebStringKey.MachineReadableDesc to "SIEM 통합용 JSON",
    WebStringKey.DateRange to "날짜 범위",
    WebStringKey.Last7Days to "지난 7일",
    WebStringKey.Last30Days to "지난 30일",
    WebStringKey.Last90Days to "지난 90일",
    WebStringKey.AllTime to "전체 기간",
    WebStringKey.CustomRange to "사용자 지정 범위",
    WebStringKey.ReportSections to "보고서 섹션",
    WebStringKey.ExecutiveSummary to "요약",
    WebStringKey.ThreatBreakdown to "위협 분석",
    WebStringKey.ScanTimeline to "스캔 타임라인",
    WebStringKey.SafeUrlList to "안전한 URL 목록",
    WebStringKey.GenerateExport to "보고서 내보내기",
    WebStringKey.Success to "성공!",
    WebStringKey.Error to "오류",
    WebStringKey.Warning to "경고",
    WebStringKey.CopiedToClipboard to "클립보드에 복사됨",
    WebStringKey.Cancel to "취소",
    WebStringKey.Confirm to "확인",
    WebStringKey.Save to "저장",
    WebStringKey.Delete to "삭제",
    WebStringKey.Edit to "편집",
    WebStringKey.Close to "닫기",
    WebStringKey.Back to "뒤로",
    WebStringKey.Next to "다음",
    WebStringKey.Previous to "이전",
    WebStringKey.Submit to "제출",
    WebStringKey.Reset to "초기화",
    WebStringKey.Clear to "지우기",
    WebStringKey.Search to "검색",
    WebStringKey.Filter to "필터",
    WebStringKey.Sort to "정렬",
    WebStringKey.ToggleMenu to "메뉴 전환",
    WebStringKey.ToggleTheme to "테마 전환",
    WebStringKey.Notifications to "알림",
    WebStringKey.Help to "도움말",
    WebStringKey.Profile to "프로필",
    WebStringKey.ToggleLightDarkMode to "라이트/다크 모드 전환",
    WebStringKey.UrlInputPlaceholder to "분석할 URL 붙여넣기",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    WebStringKey.Scan to "스캔",
    WebStringKey.Result to "결과",
    WebStringKey.ReportGeneration to "보고서 생성",
    WebStringKey.ReportGenerationDesc to "형식 설정 및 다운로드",
    WebStringKey.OfflineSecurity to "오프라인 보안",
    WebStringKey.OfflineSecurityDesc to "데이터가 기기를 떠나지 않음",
    WebStringKey.ChooseFormat to "형식 선택",
    WebStringKey.PdfFormatDesc to "PDF 형식. 공유에 최적",
    WebStringKey.JsonFormatDesc to "JSON 형식. SIEM에 최적",
    WebStringKey.Copy to "복사",
    WebStringKey.LivePreview to "라이브 미리보기",
    WebStringKey.ReadOnly to "읽기 전용",
    WebStringKey.ThreatAnalysisReport to "위협 분석 보고서",
    WebStringKey.Verdict to "판정",
    WebStringKey.RiskScore to "위험 점수",
    WebStringKey.TargetUrl to "대상 URL",
    WebStringKey.AnalysisSummaryLabel to "분석 요약",
    WebStringKey.TechnicalIndicators to "기술 지표",
    WebStringKey.ExportInfoNote to "모든 위협 벡터 포함",
    WebStringKey.AllowList to "허용 목록",
    WebStringKey.BlockList to "차단 목록",
    WebStringKey.AddDomain to "도메인 추가",
    WebStringKey.RemoveDomain to "도메인 제거",
    WebStringKey.TrustedDomains to "신뢰할 수 있는 도메인",
    WebStringKey.BlockedDomains to "차단된 도메인",
    WebStringKey.DomainPlaceholder to "도메인 입력",
    WebStringKey.Safe to "안전",
    WebStringKey.TimeAgo to "전",
    WebStringKey.MinutesAgo to "분 전",
    WebStringKey.HoursAgo to "시간 전",
    WebStringKey.Critical to "심각",
    WebStringKey.Warn to "경고",
    WebStringKey.PhishingDetectionSensitivity to "피싱 감지 민감도",
    WebStringKey.SensitivityDescription to "휴리스틱 임계값 조정",
    WebStringKey.SensitivityLow to "낮음",
    WebStringKey.SensitivityBalanced to "균형",
    WebStringKey.SensitivityParanoia to "편집증",
    WebStringKey.BalancedModeRecommended to "균형 모드 (권장)",
    WebStringKey.BalancedModeDesc to "악성 패턴 스캔",
    WebStringKey.LowSensitivityMode to "낮은 민감도 모드",
    WebStringKey.LowSensitivityModeDesc to "위협 데이터베이스에서 알려진 악성 URL만 차단합니다. 오탐지가 최소화되지만 새로운 공격을 놓칠 수 있습니다.",
    WebStringKey.ParanoiaMode to "편집증 모드",
    WebStringKey.ParanoiaModeDesc to "최대 보호. 새로 등록된 도메인, 일반적이지 않은 TLD 및 잠재적인 인코딩 트릭이 있는 모든 의심스러운 패턴을 차단합니다.",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard는 로컬 휴리스틱 분석 엔진을 사용합니다. 스캔 중에 이미지 데이터, URL 문자열 또는 메타데이터가 이 장치를 떠나지 않습니다. 귀하의 개인정보는 수학적으로 보장됩니다.",
    WebStringKey.SignalBrandImpersonation to "잠재적인 브랜드 사칭 감지됨",
    WebStringKey.SignalCredentialParams to "URL에 자격 증명 관련 매개변수",
    WebStringKey.SignalEncodedPayload to "쿼리 매개변수에서 인코딩된 데이터 감지됨",
    WebStringKey.SignalExcessiveSubdomains to "과도한 서브도메인 깊이 ({count}단계)",
    WebStringKey.SignalHighEntropyHost to "도메인 이름의 높은 무작위성",
    WebStringKey.SignalHomographAttack to "도메인에 동형이의/혼동 가능한 문자 포함",
    WebStringKey.SignalHttpNotHttps to "안전하지 않은 HTTP 프로토콜 사용",
    WebStringKey.SignalIpAddressHost to "호스트가 도메인 대신 IP 주소",
    WebStringKey.SignalLongUrl to "비정상적으로 긴 URL ({length}자)",
    WebStringKey.SignalLongUrlMarketing to "비정상적으로 긴 URL ({length}자) - 마케팅 매개변수 포함",
    WebStringKey.SignalNewlyRegisteredDomain to "새로 등록된 도메인 감지됨",
    WebStringKey.SignalNonStandardPort to "비표준 포트: {port}",
    WebStringKey.SignalNumericSubdomain to "숫자로만 된 서브도메인 감지됨",
    WebStringKey.SignalSuspiciousPathKeywords to "경로에 의심스러운 키워드 ({count}개 발견)",
    WebStringKey.SignalSuspiciousTld to "의심스러운 TLD: {tld}",
    WebStringKey.SignalUrlShortener to "URL 단축 서비스 사용",
    WebStringKey.SecureEnvironment to "안전한 환경",
    WebStringKey.LearnLocalArchitecture to "로컬 아키텍처 알아보기",
    WebStringKey.NoCustomDomainsBlocked to "차단된 사용자 지정 도메인 없음",
    WebStringKey.AddManually to "수동으로 추가",
    WebStringKey.AddedDaysAgo to "2일 전 추가됨",
    WebStringKey.AddedWeekAgo to "1주 전 추가됨",
    WebStringKey.PrivacyControls to "개인정보 제어",
    WebStringKey.StrictOfflineMode to "엄격한 오프라인 모드",
    WebStringKey.DisableExternalPreviews to "외부 미리보기 비활성화",
    WebStringKey.AnonymousTelemetry to "익명 텔레메트리",
    WebStringKey.ShareDetectionStats to "탐지 통계 공유",
    WebStringKey.AutoCopySafeLinks to "안전한 링크 자동 복사",
    WebStringKey.CopyTrustedUrls to "신뢰할 수 있는 URL 복사",
    WebStringKey.AboutMehrGuard to "Mehr Guard 정보",
    WebStringKey.OpenSourceLicenses to "오픈 소스 라이선스",
    WebStringKey.PrivacyPolicy to "개인정보 처리방침",
    WebStringKey.Acknowledgements to "감사의 글",
    WebStringKey.ResetAllSettings to "모든 설정 초기화",
    WebStringKey.AddToAllowlist to "허용 목록에 추가",
    WebStringKey.AddToBlocklist to "차단 목록에 추가",
    WebStringKey.AnalysedOfflineTitle to "오프라인 분석",
    WebStringKey.YourDataStaysOnDevice to "데이터가 기기에 유지됨",
    WebStringKey.OnboardingHeroDesc to "안전한 온디바이스 분석",
    WebStringKey.OnDeviceAnalysis to "온디바이스 분석",
    WebStringKey.OnDeviceAnalysisDesc to "모든 위협 탐지 로컬 실행",
    WebStringKey.NoCloudLogs to "클라우드 로그 없음",
    WebStringKey.NoCloudLogsDesc to "발신 텔레메트리 비활성화",
    WebStringKey.OnDeviceDB to "온디바이스 DB",
    WebStringKey.OnDeviceDBDesc to "전체 위협 서명 DB",
    WebStringKey.DataLifecycleVerification to "데이터 수명 주기 검증",
    WebStringKey.SecurityAuditPass to "보안 감사: 통과",
    WebStringKey.Copyright to "© 2024 Mehr Guard Security Inc.",
    WebStringKey.Support to "지원",
    WebStringKey.Terms to "이용약관",
    WebStringKey.SystemsOperational to "시스템 가동 중",
    WebStringKey.SystemSecure to "시스템 안전",
    WebStringKey.VersionStatus to "v2.4.1 • 시스템 안전",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2024.12.19",
    WebStringKey.VerifiedBy to "Mehr Guard Enterprise 인증",
    WebStringKey.SampleUserName to "김철수",
    WebStringKey.SampleUserRole to "보안 분석가",
    WebStringKey.DetailLabel to "상세 라벨",
    WebStringKey.DetailValue to "상세 값",
    WebStringKey.Suspicious to "의심스러움",
    WebStringKey.IncorrectDecision to "틀린 결정",
    WebStringKey.WrongAnswer to "앗! 틀렸습니다",
    WebStringKey.ResponseTime to "응답 시간",
    WebStringKey.IncomingMessage to "수신 메시지",
    WebStringKey.CertificateIssuer to "인증서 발급자 일치",
    WebStringKey.DomainAgeTrust to "도메인 연령 > 5년",
    WebStringKey.WhitelistedRank to "Alexa 상위 1k",
    WebStringKey.GameEducationalNote to "교육 노트",
    WebStringKey.GameHintTitle to "게임 힌트",
    WebStringKey.AddToAllowlistTitle to "허용 목록에 추가",
    WebStringKey.AddToBlocklistTitle to "차단 목록에 추가",
    WebStringKey.EnterDomainPrompt to "도메인 입력",
    WebStringKey.LatencyMs to "지연 시간",
    WebStringKey.StreakFire to "연속",
    WebStringKey.AccuracyPercent to "정확도",
    WebStringKey.ConfidencePercent to "신뢰도",
    WebStringKey.English to "영어",
    WebStringKey.German to "독일어",
    WebStringKey.Spanish to "스페인어",
    WebStringKey.French to "프랑스어",
    WebStringKey.ChineseSimplified to "중국어(간체)",
    WebStringKey.Japanese to "일본어",
    WebStringKey.Hindi to "힌디어",
    WebStringKey.Arabic to "아랍어",
    WebStringKey.Indonesian to "인도네시아어",
    WebStringKey.Italian to "이탈리아어",
    WebStringKey.Korean to "한국어",
    WebStringKey.Portuguese to "포르투갈어",
    WebStringKey.Russian to "러시아어",
    WebStringKey.Thai to "태국어",
    WebStringKey.Turkish to "터키어",
    WebStringKey.Vietnamese to "베트남어"
,
    WebStringKey.ComponentVoting to "구성 요소 투표",
    WebStringKey.Heuristic to "휴리스틱",
    WebStringKey.MLModel to "ML 모델",
    WebStringKey.Brand to "브랜드",
    WebStringKey.TLD to "TLD",
    WebStringKey.VotingExplanation to "다수결로 판정: 3+ 안전=녹색, 2+ 악성=빨강"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "스캔 대기 중...",
    WebStringKey.WaitingForAnalysis to "분석 대기 중...",
    WebStringKey.ScanURLToSeeResults to "URL을 스캠하여 상세 결과를 확인하세요.",

    // Keyboard Shortcuts & Settings
    WebStringKey.KeyboardShortcuts to "키보드 단축키",
    WebStringKey.StartScanner to "스캠너 시작",
    WebStringKey.CloseMenuModal to "메뉴 / 모달 닫기",
    WebStringKey.NavigateToDashboard to "대시보드로 이동",
    WebStringKey.NavigateToHistory to "스캠 기록",
    WebStringKey.NavigateToTrust to "신뢰 센터 / 허용 목록",
    WebStringKey.NavigateToGame to "봇을 이겨라 게임",
    WebStringKey.ShowHelp to "도움말 보기",
    WebStringKey.GotIt to "알겠습니다",
    WebStringKey.SecuritySettings to "보안 설정",
    WebStringKey.SensitivityLevel to "민감도 수준",
    WebStringKey.AutoBlockThreats to "위협 자동 차단",
    WebStringKey.RealTimeScanning to "실시간 스캠",
    WebStringKey.SoundAlerts to "소리 알림",
    WebStringKey.ThreatAlerts to "위협 알림",
    WebStringKey.ShowConfidenceScore to "신뢰도 점수 표시",
    WebStringKey.CompactView to "컴팩트 보기",
    WebStringKey.ResetDefaults to "기본값으로 재설정",
    WebStringKey.SaveAndContinue to "저장 및 계속",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "Mehr Guard Security 정보",
    WebStringKey.ActualDomain to "실제 도메인",
    WebStringKey.AnalysisComplete to "분석 완료",
    WebStringKey.AutoBlockThreatsDesc to "위협 자동 차단",
    WebStringKey.AwaitingScanLabel to "스캔 대기 중",
    WebStringKey.BrandImpersonation to "브랜드 사칭",
    WebStringKey.CautionAdvised to "주의 권장",
    WebStringKey.CompactViewDesc to "컴팩트 보기",
    WebStringKey.DoNotVisit to "방문하지 마세요",
    WebStringKey.DoNotVisitDesc to "높은 신뢰도의 피싱 감지. 이 URL은 여러 악성 지표를 보입니다.",
    WebStringKey.DomainUsesInternationalChars to "이 도메인은 합법적인 도메인을 모방할 수 있는 국제 문자를 사용합니다.",
    WebStringKey.GoToScanner to "스캐너로 이동",
    WebStringKey.Hebrew to "히브리어",
    WebStringKey.HelpKeyboardShortcuts to "키보드 단축키",
    WebStringKey.HeuristicAnalysis to "휴리스틱 분석",
    WebStringKey.HeuristicAnalysisDesc to "분석 엔진에서 감지한 여러 위험 요소를 기반으로 URL에 플래그가 지정되었습니다.",
    WebStringKey.HiddenDestination to "숨겨진 목적지",
    WebStringKey.HighRisk to "고위험",
    WebStringKey.HighRiskLabel to "고위험",
    WebStringKey.HomographIdnAttack to "호모그래프 / IDN 공격",
    WebStringKey.InternationalizedDomainDetected to "국제화 도메인 이름이 감지되었습니다.",
    WebStringKey.JustNow to "방금",
    WebStringKey.KeyboardShortcutsDesc to "빠른 접근을 위한 키보드 단축키",
    WebStringKey.LiveFeedActive to "라이브 피드 활성",
    WebStringKey.LowRisk to "저위험",
    WebStringKey.LowRiskLabel to "저위험",
    WebStringKey.Malicious to "악성",
    WebStringKey.MediumRiskLabel to "중간 위험",
    WebStringKey.NoData to "데이터 없음",
    WebStringKey.NoScanDataResults to "스캔 데이터가 없습니다. URL을 스캔하여 분석 결과를 확인하세요.",
    WebStringKey.NoUrlScanned to "스캔된 URL 없음",
    WebStringKey.Persian to "페르시아어",
    WebStringKey.PhishingIndicators to "피싱 지표",
    WebStringKey.ProceedWithCaution to "주의하여 진행하세요",
    WebStringKey.ProceedWithCautionDesc to "일부 의심스러운 지표가 감지되었습니다. 민감한 정보를 입력하기 전에 출처를 확인하세요.",
    WebStringKey.RealTimeScanningDesc to "실시간 스캔",
    WebStringKey.RedirectShortenerDetected to "리디렉션/단축 감지",
    WebStringKey.SafeToVisit to "방문 안전",
    WebStringKey.SafeToVisitDesc to "로컬 휴리스틱 v2.4로 검증됨. 피싱 패턴, 난독화 스크립트 또는 블랙리스트 일치가 발견되지 않았습니다.",
    WebStringKey.SafetyScore to "안전 점수",
    WebStringKey.ScanCompleteLabel to "스캔 완료",
    WebStringKey.ScanToAnalyze to "QR 코드를 스캔하거나 URL을 입력하여 분석하세요.",
    WebStringKey.ScannedURLLabel to "스캔된 URL",
    WebStringKey.SecuritySignal to "보안 신호",
    WebStringKey.SensitivityLevelDesc to "민감도 수준",
    WebStringKey.SensitivityPermissive to "허용적",
    WebStringKey.SensitivityStrict to "엄격",
    WebStringKey.SettingsDetection to "감지",
    WebStringKey.SettingsDisplay to "표시",
    WebStringKey.SettingsLanguage to "언어",
    WebStringKey.SettingsLanguageDesc to "UI 언어 선택",
    WebStringKey.SettingsNotifications to "알림",
    WebStringKey.SettingsSavedAutomatically to "설정은 자동으로 저장되고 세션 간에 동기화됩니다.",
    WebStringKey.ShowConfidenceScoreDesc to "신뢰 점수 표시",
    WebStringKey.SoundAlertsDesc to "소리 알림",
    WebStringKey.SuspiciousDomain to "의심스러운 도메인",
    WebStringKey.SuspiciousEncoding to "의심스러운 인코딩",
    WebStringKey.SuspiciousKeywords to "의심스러운 키워드",
    WebStringKey.SuspiciousTld to "의심스러운 TLD",
    WebStringKey.SuspiciousTldDesc to "도메인은 일반적으로 악성 사이트와 관련된 {tld} TLD를 사용합니다.",
    WebStringKey.SuspiciousUrlParams to "의심스러운 URL 매개변수",
    WebStringKey.SuspiciousUrlParamsDesc to "URL에 복잡하거나 잠재적으로 난독화된 매개변수가 포함되어 있습니다.",
    WebStringKey.ThreatAlertsDesc to "위협 알림",
    WebStringKey.ThreatDetected to "위협 감지",
    WebStringKey.UnableToDetermine to "판정을 결정할 수 없습니다. 다시 시도해 주세요.",
    WebStringKey.Unknown to "알 수 없음",
    WebStringKey.UnknownURL to "알 수 없는 URL",
    WebStringKey.UrlShortenerDesc to "URL은 최종 목적지를 숨기는 단축 서비스를 사용합니다.",
    WebStringKey.UrlShortenerDetected to "URL 단축 감지",
    WebStringKey.VersionOfflineReady to "오프라인 준비 완료",
    WebStringKey.VisualAppearance to "시각적 외관",
    WebStringKey.WaitingForAnalysisLabel to "분석 대기 중...",

    // Reason Code Titles and Descriptions (for i18n of attack analysis cards)
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "JavaScript URL",
    WebStringKey.ReasonJavascriptUrlDesc to "JavaScript URL 스킴 감지 - 클릭 시 코드 실행",
    WebStringKey.ReasonDataUriTitle to "데이터 URI",
    WebStringKey.ReasonDataUriDesc to "데이터 URI 스킴 감지 - 악성 코드가 포함되어 있을 수 있음",
    WebStringKey.ReasonAtSymbolInjectionTitle to "@ 기호 주입",
    WebStringKey.ReasonAtSymbolInjectionDesc to "URL에 @ 기호가 포함되어 있어 자격 증명 도용 시도 가능성",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "호모그래프 공격",
    WebStringKey.ReasonHomographDesc to "국제화된 도메인 이름(IDN)이 다른 도메인을 가장할 수 있음",
    WebStringKey.ReasonMixedScriptTitle to "혼합 스크립트",
    WebStringKey.ReasonMixedScriptDesc to "호스트명에 여러 스크립트의 문자가 포함됨 (스푸핑 가능성)",
    WebStringKey.ReasonLookalikeCharsTitle to "유사 문자",
    WebStringKey.ReasonLookalikeCharsDesc to "도메인에 ASCII 문자처럼 보이는 유니코드 문자 포함",
    WebStringKey.ReasonZeroWidthCharsTitle to "너비 없는 문자",
    WebStringKey.ReasonZeroWidthCharsDesc to "숨겨진 너비 없는 유니코드 문자 감지 (난독화 시도)",
    WebStringKey.ReasonIpHostTitle to "IP 호스트",
    WebStringKey.ReasonIpHostDesc to "URL이 도메인 이름 대신 IP 주소 사용",
    WebStringKey.ReasonCredentialParamTitle to "자격 증명 매개변수",
    WebStringKey.ReasonCredentialParamDesc to "URL에 자격 증명 관련 매개변수 포함 (비밀번호, 토큰 등)",
    WebStringKey.ReasonBrandImpersonationTitle to "브랜드 사칭",
    WebStringKey.ReasonBrandImpersonationDesc to "URL이 알려진 브랜드를 사칭하는 것으로 보임",
    WebStringKey.ReasonBrandInSubdomainTitle to "서브도메인의 브랜드",
    WebStringKey.ReasonBrandInSubdomainDesc to "브랜드 이름이 서브도메인에는 있지만 주 도메인에는 없음",
    WebStringKey.ReasonRiskyExtensionTitle to "위험한 확장자",
    WebStringKey.ReasonRiskyExtensionDesc to "경로에 잠재적으로 위험한 파일 확장자 포함",
    WebStringKey.ReasonDoubleExtensionTitle to "이중 확장자",
    WebStringKey.ReasonDoubleExtensionDesc to "이중 파일 확장자 감지 (일반적인 악성코드 전술)",
    WebStringKey.ReasonEncodedPayloadTitle to "인코딩된 페이로드",
    WebStringKey.ReasonEncodedPayloadDesc to "URL 매개변수에서 대량의 인코딩된 데이터 감지",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP (HTTPS 아님)",
    WebStringKey.ReasonHttpNotHttpsDesc to "URL이 HTTPS 대신 안전하지 않은 HTTP 프로토콜 사용",
    WebStringKey.ReasonSuspiciousTldTitle to "의심스러운 TLD",
    WebStringKey.ReasonSuspiciousTldDesc to "최상위 도메인이 피싱에 자주 사용됨",
    WebStringKey.ReasonHighEntropyHostTitle to "높은 엔트로피 호스트",
    WebStringKey.ReasonHighEntropyHostDesc to "도메인 이름이 무작위로 생성된 것으로 보임",
    WebStringKey.ReasonRedirectParamTitle to "리디렉션 매개변수",
    WebStringKey.ReasonRedirectParamDesc to "URL에 다른 사이트로 연결될 수 있는 리디렉션 매개변수 포함",
    WebStringKey.ReasonDeepSubdomainTitle to "깊은 서브도메인",
    WebStringKey.ReasonDeepSubdomainDesc to "과도한 서브도메인 깊이 (실제 도메인을 숨길 수 있음)",
    WebStringKey.ReasonMultiTldTitle to "다중 TLD",
    WebStringKey.ReasonMultiTldDesc to "도메인 이름에 TLD와 유사한 여러 세그먼트",
    WebStringKey.ReasonNumericSubdomainTitle to "숫자 서브도메인",
    WebStringKey.ReasonNumericSubdomainDesc to "숫자로만 구성된 서브도메인 감지",
    WebStringKey.ReasonNonStandardPortTitle to "비표준 포트",
    WebStringKey.ReasonNonStandardPortDesc to "URL이 비표준 포트 번호 사용",
    WebStringKey.ReasonSuspiciousPortTitle to "의심스러운 포트",
    WebStringKey.ReasonSuspiciousPortDesc to "URL이 공격과 일반적으로 관련된 포트 사용",
    WebStringKey.ReasonFragmentHidingTitle to "프래그먼트 숨김",
    WebStringKey.ReasonFragmentHidingDesc to "URL 프래그먼트가 추가 콘텐츠를 숨기는 것으로 보임",
    WebStringKey.ReasonExcessiveEncodingTitle to "과도한 인코딩",
    WebStringKey.ReasonExcessiveEncodingDesc to "과도한 URL 인코딩 감지 (난독화 시도)",
    WebStringKey.ReasonDomainAgePatternTitle to "도메인 연령 패턴",
    WebStringKey.ReasonDomainAgePatternDesc to "도메인 이름이 자동 생성된 도메인의 패턴과 일치",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "URL 단축기",
    WebStringKey.ReasonUrlShortenerDesc to "URL이 단축 서비스 사용 (실제 목적지를 숨김)",
    WebStringKey.ReasonSuspiciousPathTitle to "의심스러운 경로",
    WebStringKey.ReasonSuspiciousPathDesc to "경로에 의심스러운 키워드 포함 (login, verify 등)",
    WebStringKey.ReasonLongUrlTitle to "긴 URL",
    WebStringKey.ReasonLongUrlDesc to "비정상적으로 긴 URL",
    WebStringKey.ReasonCredentialKeywordsTitle to "자격 증명 키워드",
    WebStringKey.ReasonCredentialKeywordsDesc to "URL에 자격 증명 수집 키워드 포함",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "파싱 불가 URL",
    WebStringKey.ReasonUnparseableDesc to "URL을 완전히 파싱할 수 없음",
    WebStringKey.ReasonAnalysisCompleteTitle to "분석 완료",
    WebStringKey.ReasonAnalysisCompleteDesc to "분석이 성공적으로 완료됨",

    // ML Score Labels
    WebStringKey.MlPhishingScore to "ML 피싱 점수",
    WebStringKey.MlCharacterAnalysis to "문자 분석",
    WebStringKey.MlFeatureAnalysis to "기능 분석",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "IDN / Punycode 도메인",
    WebStringKey.IdnPunycodeDomainDesc to "이 도메인은 국제화 문자를 사용합니다. 안전한 표시:",
    WebStringKey.MixedScriptAttackTitle to "혼합 스크립트 공격",
    WebStringKey.MixedScriptAttackDesc to "도메인에 여러 스크립트의 문자가 포함되어 있습니다 (예: 키릴 문자 + 라틴 문자). 호모그래프 공격에서 일반적입니다.",
    WebStringKey.ConfusableCharsTitle to "혼동 가능한 문자",
    WebStringKey.ConfusableCharsDesc to "도메인에 일반 문자와 유사한 문자가 포함되어 있습니다 (예: 'а' vs 'a')."
)

internal val KoreanCommonStrings = mapOf(
    "Engine Active" to "엔진 활성화",
    "Enterprise Protection Active" to "기업 보호 활성화",
    "Start New Scan" to "새 스캔 시작",
    "Import Image" to "이미지 가져오기",
    "System Health" to "시스템 상태",
    "Threat Database" to "위협 데이터베이스",
    "Current" to "현재",
    "Heuristic Engine" to "휴리스틱 엔진",
    "Active" to "활성",
    "Threats" to "위협",
    "Safe Scans" to "안전한 스캔",
    "Recent Scans" to "최근 스캔",
    "View Full History" to "전체 기록 보기",
    "Status" to "상태",
    "Source" to "소스",
    "Details" to "세부 정보",
    "Time" to "시간",
    "SAFE" to "안전",
    "SUSPICIOUS" to "의심스러움",
    "PHISHING" to "피싱",
    "UNKNOWN" to "알 수 없음",
    "Version" to "버전",
    "Last Update" to "마지막 업데이트",
    "Signatures" to "서명",
    "Check for Updates" to "업데이트 확인",
    "Active Scanner" to "활성 스캐너",
    "Offline Mode" to "오프라인 모드",
    "Camera Access Required" to "카메라 액세스 필요",
    "Enable Camera" to "카메라 활성화",
    "Scanning..." to "스캔 중...",
    "Torch" to "손전등",
    "Gallery" to "갤러리",
    "Paste URL" to "URL 붙여넣기",
    "Analyze URL" to "URL 분석",
    "Analyze" to "분석",
    "READY" to "준비",
    "Local DB" to "로컬 DB",
    "Latency" to "지연",
    "View All" to "모두 보기",
    "Dashboard" to "대시보드",
    "Settings" to "설정",
    "Training Centre" to "교육 센터",
    "Beat the Bot" to "봇을 이겨라",
    "Safe" to "안전",
    "Suspicious" to "의심스러움",
    "Dangerous" to "위험",
    "Phishing" to "피싱",
    "Legitimate" to "합법적",
    "Block & Report" to "차단 및 신고",
    "Copy Link" to "링크 복사",
    "Share" to "공유",
    "Export Report" to "보고서 내보내기",
    "Clear All" to "모두 삭제",
    "Cancel" to "취소",
    "Close" to "닫기",
    "Back to Dashboard" to "대시보드로 돌아가기",
    "Scan Complete" to "스캔 완료",
    "High Risk" to "높은 위험",
    "Low Risk" to "낮은 위험",
    "Risk Score" to "위험 점수",
    "Confidence" to "신뢰도",
    "Homograph Attack" to "동형 문자 공격",
    "Detected" to "감지됨",
    "한국어" to "한국어",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "의심스러운 활동",
    WebStringKey.VerdictWarning to "경고",
    WebStringKey.VerdictSuspiciousDesc to "스캔된 QR 코드가 잠재적 보안 위험을 나타낼 수 있는 의심스러운 패턴을 보여줍니다. 주의하여 진행하십시오.",
    WebStringKey.VerdictMinorConcerns to "경미한 우려",
    WebStringKey.VerdictCaution to "주의",
    WebStringKey.VerdictMinorConcernsDesc to "몇 가지 경미한 보안 우려가 식별되었습니다. 링크가 대체로 안전해 보이지만 검토를 권장합니다.",
    WebStringKey.VerdictVerifiedSafe to "확인됨 안전",
    WebStringKey.VerdictSafeLabel to "안전",
    WebStringKey.VerdictVerifiedSafeDesc to "보안 위협이 감지되지 않았습니다. QR 코드가 확인된 안전한 목적지로 연결됩니다.",
    WebStringKey.VerdictNoActivity to "활동 없음",
    WebStringKey.VerdictAwaitingScan to "스캔 대기 중",
    WebStringKey.VerdictNoActivityDesc to "스캔 데이터가 없습니다. QR 코드를 스캔하거나 분석할 URL을 입력하십시오.",
    WebStringKey.ScanQrToSeeActivity to "QR 코드를 스캔하여 여기에서 활동을 확인하세요",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "데이터 포인트",
    WebStringKey.ProcessingEnv to "처리 환경",
    WebStringKey.ExternalTransmission to "외부 전송",
    WebStringKey.RawImageBuffer to "원시 이미지 버퍼",
    WebStringKey.LocalMemoryRam to "로컬 메모리 (RAM)",
    WebStringKey.TransmissionNone to "없음",
    WebStringKey.DecodedUrlPayload to "디코딩된 URL/페이로드",
    WebStringKey.LocalAnalysis to "로컬 분석",
    WebStringKey.ThreatVerdictLabel to "위협 판정",
    WebStringKey.LocalDatabase to "로컬 데이터베이스"
)
